var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiwisLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1242 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.671,91.508c0,-39.95 -29.833,-89.487 -102.279,-89.487l-112.392,-0l58,60.725l49.067,-0c25.571,-0 38.354,14.383 38.354,33.558c-0,14.384 -7.458,22.904 -20.775,36.225l-44.971,46.892l79.596,83.079l90.025,0l-77.771,-80.967c30.896,-32.495 43.146,-51.137 43.146,-90.025Z",
    style: {
      fill: "#00697c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.571,
    y: 2.021,
    width: 76.708,
    height: 260.479,
    style: {
      fill: "#00697c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891.18,
    y: 2.021,
    width: 76.704,
    height: 260.479,
    style: {
      fill: "#00697c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.03,109.088c-43.679,-15.98 -59.129,-20.775 -59.129,-32.492c0,-10.654 8.525,-13.85 17.046,-13.85l91.087,-0l13.321,-60.725l-112.929,-0c-49.008,-0 -82.033,29.296 -82.033,68.712c-0,45.813 19.175,62.859 74.041,83.1c46.875,17.046 51.675,21.309 51.675,33.563c0,9.587 -6.929,14.379 -19.179,14.379l-107.071,0l0,60.725l107.605,0c52.2,0 92.154,-26.1 92.154,-74.042c-0,-48.475 -24.504,-63.92 -66.588,-79.37Z",
    style: {
      fill: "#00697c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.392,151.704l-50.604,-149.683l-67.117,-0l-50.604,149.683l-44.746,-149.683l-79.371,-0l82.034,260.479l76.175,0l50.071,-142.225l50.075,142.225l76.171,0l82.037,-260.479l-79.371,-0l-44.75,149.683Z",
    style: {
      fill: "#00697c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.021l124.646,130.508l-124.646,129.971l0,-260.479Z",
    style: {
      fill: "#cddc36",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiwisLogoColor);
export default __webpack_public_path__ + "static/media/riwis_logo_color.95fc882ed629fb2b47423ad6fd20c56d.svg";
export { ForwardRef as ReactComponent };